// src/components/visits/VisitsFilters.jsx
import React from 'react';
import { Filter } from 'lucide-react';
import { useTheme } from '../../theme/ThemeContext';

const badgeBase =
  'inline-flex items-center rounded-full px-3 py-1 text-xs font-medium transition';

const VisitsFilters = ({
  statusFilter,
  onStatusFilterChange,
  approveFilter,
  onApproveFilterChange,
  runTypeFilter,
  onRunTypeFilterChange,
  visibleCount,
  totalVisits,
}) => {
  const { theme } = useTheme();

  return (
    <section className="mb-4 flex flex-col items-start justify-between gap-3 rounded-xl border border-slate-200 bg-white/80 p-3 shadow-sm dark:border-slate-700 dark:bg-slate-900/80 md:flex-row md:items-center">
      <div className="flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400">
        <Filter className="h-4 w-4 text-slate-400" />
        <span className="font-medium">Filters</span>
        <span className="hidden sm:inline">
          Showing <strong>{visibleCount}</strong> of{' '}
          <strong>{totalVisits}</strong> visits
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        {/* Status */}
        <select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          className="rounded-full border border-slate-200 bg-transparent px-3 py-1 text-xs outline-none dark:border-slate-700"
        >
          <option value="all">All statuses</option>
          <option value="captured">Captured</option>
          <option value="uploading">Uploading</option>
          <option value="uploaded">Uploaded</option>
          <option value="delivered">Delivered</option>
        </select>

        {/* Approval */}
        <select
          value={approveFilter}
          onChange={(e) => onApproveFilterChange(e.target.value)}
          className="rounded-full border border-slate-200 bg-transparent px-3 py-1 text-xs outline-none dark:border-slate-700"
        >
          <option value="all">All approvals</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>

        {/* Run type */}
        <select
          value={runTypeFilter}
          onChange={(e) => onRunTypeFilterChange(e.target.value)}
          className="rounded-full border border-slate-200 bg-transparent px-3 py-1 text-xs outline-none dark:border-slate-700"
        >
          <option value="all">All run types</option>
          <option value="auto">Auto</option>
          <option value="manual">Manual</option>
        </select>

        <span
          className={`${badgeBase} border border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-700 dark:bg-slate-900/60 dark:text-slate-300`}
        >
          {visibleCount} shown
        </span>
      </div>
    </section>
  );
};

export default VisitsFilters;
